import React from "react";
import { useSelector } from "react-redux";

const Steps = ({
  stepsList = [],
}) => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentStep, currentSubStep } = clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const stepClassName = (step) => {    
    if (step !== currentStep && stepsList[step-1].subSteps.every(s => !s.show)) {
      return "bg-gray-50 text-REELTeal";
    }

    if (currentStep >= step) {
      return "bg-blue-100 text-REELTeal ";
    }
    return "text-REELTeal";
  };

  return (
    <nav aria-label="Progress">
      <div className="w-full border-gray-50 border-[2px] flex items-center justify-center rounded-[5px] ">
        {stepsList && stepsList?.map((step, index) => {
          return (
            <button
              key={index}
              className={`h-[52px] w-full flex flex-col items-center justify-center text-body-md font-medium ${stepClassName(
                index + 1
              )} ${index !== stepsList.length - 1 ? "border-r-[2px] border-gray-50" : ""}
               `}
            >
              <p>{step.name}</p>
              <div className="flex items-center justify-center space-x-2">
                {index + 1 === currentStep
                  && step?.subSteps?.filter(s => s.show).map((subStep, subIndex) => {
                    return (
                      <div
                        key={subIndex}
                        className={`h-[10px] w-[10px] rounded-full ${(currentSubStep >= subIndex + 1)
                          ? "bg-REELTeal"
                          : "bg-gray-200"
                          }`}
                      />
                    );
                  })
                  }
              </div>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default Steps;
